import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDetailsTitle: {
        id: 'tfpa.policyChangeTfpa.wizard.step.Policy Details',
        defaultMessage: 'Policy Details',
    },
})